
import Vue from "vue";
import Picture from "@/components-ui/Picture/Picture.vue";
import { Home } from "./Home.interface";
import arbreFleuriJpg from "@/assets/images/pictures/arbre_fleuri.jpg";
import arbreFleuriWebp from "@/assets/images/pictures/arbre_fleuri.webp";
import arbreFleuriWebpMobile from "@/assets/images/pictures/arbre_fleuri-mobile.webp";
import nenupharJpg from "@/assets/images/pictures/plateau_nenuphar.jpg";
import nenupharWebp from "@/assets/images/pictures/plateau_nenuphar.webp";
import nenupharWebpMobile from "@/assets/images/pictures/plateau_nenuphar-mobile.webp";
import defaultImageForSharingJpg from "@/assets/images/pictures/nathalie_de_loeper_praticienne_shiatsu.jpg";
import { homePageSchemaContext, localBusiness } from "@/data/googleSchemas";

export default Vue.extend({
  name: "Home",
  components: {
    Picture,
  },
  data(): Home {
    return {
      landingPicture: {
        defaultImage: arbreFleuriJpg,
        imageWebp: arbreFleuriWebp,
        imageWebpMobile: arbreFleuriWebpMobile,
        loadImage: true,
      },
      nenuphar: {
        defaultImage: nenupharJpg,
        imageWebp: nenupharWebp,
        imageWebpMobile: nenupharWebpMobile,
        loadImage: false,
      },
    };
  },
  methods: {
    lazyLoadImage(section: MouseEvent): void {
      if (section.offsetY > 200) {
        this.nenuphar.loadImage = true;
      }
    },
  },
  mounted() {
    this.$injectSchema(homePageSchemaContext);
    this.$injectSchema(localBusiness);
  },
  beforeDestroy() {
    this.$clearSchemas();
  },
  metaInfo() {
    return {
      title: "Nathalie de Loeper - Shiatsu Thérapeutique",
      link: [
        {
          rel: "canonical",
          href: "https://www.shiatsutherapie78.info/",
        },
      ],
      meta: [
        {
          name: "description",
          content:
            "Praticienne de shiatsu thérapeutique diplômée EST-UFPST à Saint-Cyr-l'École (78) et Bouloire (72). Séances pour soulager stress, fatigue, douleurs, améliorer votre bien-être et rétablir l'équilibre énergétique. Prise de rendez-vous en ligne.",
        },
        {
          name: "keywords",
          content:
            "shiatsu thérapeutique, massage, bien-être, stress, fatigue, douleurs, Saint-Cyr-l'École, Yvelines, Bouloire, Sarthe, Nathalie de Loeper, médecine alternative, énergie vitale, méridiens, relaxation",
        },
        {
          property: "og:title",
          content: "Nathalie de Loeper - Shiatsu Thérapeutique | Saint-Cyr-l'École & Bouloire",
        },
        {
          property: "og:url",
          content: "https://www.shiatsutherapie78.info",
        },
        {
          property: "og:description",
          content:
            "Praticienne de shiatsu thérapeutique diplômée. Séances pour soulager stress, fatigue, douleurs. Cabinet à Saint-Cyr-l'École (78) et Bouloire (72). Prise de rendez-vous.",
        },
        { property: "og:type", content: "website" },
        {
          property: "og:image",
          content: `https://www.shiatsutherapie78.info${defaultImageForSharingJpg}`,
        },
        {
          name: "twitter:title",
          content: "Nathalie de Loeper - Shiatsu Thérapeutique",
        },
        {
          name: "twitter:description",
          content:
            "Praticienne de shiatsu thérapeutique à Saint-Cyr-l'École et Bouloire. Soulagez stress, fatigue et douleurs.",
        },
        {
          name: "geo.region",
          content: "FR-78",
        },
        {
          name: "geo.placename",
          content: "Saint-Cyr-l'École",
        },
        {
          name: "geo.position",
          content: "48.809106;2.05806",
        },
      ],
      script: [
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(homePageSchemaContext),
        },
        {
          type: "application/ld+json",
          innerHTML: JSON.stringify(localBusiness),
        },
      ],
    };
  },
});
